import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faExpandArrowsAlt,
  faTimes,
  faTimesCircle,
  faPlus,
  faMinus,
  faUserCircle,
  faLock,
  faLockOpen,
  faImage,
  faWindowClose,
  faDice,
  faUserCog,
  faLink,
  faPlayCircle,
  faFileAudio,
  faStopCircle,
  faPen,
  faTrash,
  faCheckCircle,
  faMusic,
  faVolumeDown,
  faSync,
  faClone,
  faStickyNote,
  faWrench,
  faReply,
  faArrowUp,
  faArrowDown,
  faThumbtack,
  faChessRook
} from '@fortawesome/free-solid-svg-icons'

library.add(
  faExpandArrowsAlt,
  faTimes,
  faTimesCircle,
  faPlus,
  faMinus,
  faUserCircle,
  faLock,
  faLockOpen,
  faImage,
  faWindowClose,
  faDice,
  faUserCog,
  faLink,
  faPlayCircle,
  faFileAudio,
  faStopCircle,
  faPen,
  faTrash,
  faCheckCircle,
  faMusic,
  faVolumeDown,
  faSync,
  faClone,
  faStickyNote,
  faWrench,
  faReply,
  faArrowUp,
  faArrowDown,
  faThumbtack,
  faChessRook
)
